<template>
  <div>
    <app-header title="Themes" subtitle="Media Category">
      <b-button
        v-router-link="{ name:'theme-editor', params: { id: 'new' } }"
        variant="primary"
      >
        <i class="fa fa-plus-circle" /> New Theme
      </b-button>
    </app-header>
    <loading-spinner v-if="!themes" />
    <b-container v-else>
      <b-row>
        <b-col>
          <search-input v-model="query" />
        </b-col>
        <b-col class="text-right">
          {{ total }} Themes
        </b-col>
      </b-row>
      <b-card-group columns>
        <b-card
          v-for="theme in displayThemes"
          :key="theme.id"
          v-router-link="{ name: 'theme-detail', params: theme }"
          no-body
        >
          <img :src="'https://cdn.gokaizen.com/' + theme.src" alt="" style="max-width:100%;">
          <b-card-body>
            <h3>{{ theme.name }}</h3>
            <p>{{ theme.category_name }}</p>
          </b-card-body>
        </b-card>
      </b-card-group>
      <infinite-scrolling @infiniteHandler="infiniteHandler" />
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';
import InfiniteScrolling from '@/components/InfiniteScrolling';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
    InfiniteScrolling,
  },

  data() {
    return {
      query: '',
      themes: null,
      page: 0,
      perPage: 5,
    };
  },

  computed: {
    displayThemes() {
      return $search(this.themes, this.query, ['name', 'category_name']).slice(0, this.perPage * this.page);
    },

    total() {
      return (this.query) ? this.displayThemes.length : this.themes.length;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      $api.get('/v1/internal/themes').then((themes) => {
        this.themes = themes;
      });
    },

    infiniteHandler($state) {
      if ((this.perPage * this.page) <= this.themes.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
};
</script>
